import React from 'react';
import { STORAGE } from '../../../constants/Storage';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ADMIN_ROUTE_NAME } from '../../../constants/RouteName';

const ProtectRoute = () => {
  const isLoggedIn = !!localStorage.getItem(STORAGE.TOKEN);
  const location = useLocation();

  const publicRoutes = [`/${ADMIN_ROUTE_NAME.PRIVACY_POLICY}`, `/${ADMIN_ROUTE_NAME.TERMS_OF_SERVICE}`];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  return isLoggedIn || isPublicRoute ? <Outlet /> : <Navigate to={ADMIN_ROUTE_NAME.SIGNIN} />;
};

export default ProtectRoute;
